module.exports = __webpack_public_path__ + "static/img/qr-code-2.5c03391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr-code-2.png
// module id = bcGi
// module chunks = 0